import { capitalizeString } from '@/utils/capitalizeString';
import { VideoTag } from './types';
import { TagProps } from '@/components/Tag';
import { getCurrentBrand } from '@/utils/getCurrentBrand';
import { uniqBy } from 'lodash-es';

const brand = getCurrentBrand();

export const filterVideoTags = (
  tags?: VideoTag[],
  options?: { excludeTechTag?: boolean; excludeGoneTag?: boolean; excludeRedirectTag?: boolean },
) => {
  const defaultOptions = { excludeTechTag: true, excludeGoneTag: true, excludeRedirectTag: false };
  const { excludeTechTag, excludeGoneTag, excludeRedirectTag } = { ...defaultOptions, ...options };

  const filters: ((tag: VideoTag) => boolean)[] = [];

  if (excludeTechTag) filters.push((tag: VideoTag) => !tag.isTech);
  if (excludeGoneTag) filters.push((tag: VideoTag) => !tag.isGone);
  if (excludeRedirectTag) filters.push((tag: VideoTag) => !tag.redirectTo);

  return tags?.filter((tag: VideoTag) => filters.every((filterFn) => filterFn(tag))) ?? [];
};

export const convertVideoTagsToTagProps = (tags?: VideoTag[]): TagProps[] => {
  const filtered = filterVideoTags(tags).map((tag: VideoTag) => {
    const href = tag.redirectTo ? tag.redirectTo.split(brand.host).pop() || '/video' : `/video/tag/${tag.name}`;
    const value = href.split('/').pop() || '';

    return {
      value: capitalizeString(value),
      link: { href },
    };
  });

  return uniqBy(filtered, 'value');
};
